/**
 * How long a finished sign-in popup waits for the taskpane that opened it. MSAL in that taskpane
 * polls the popup's URL every few milliseconds and closes it as soon as it reads the response, so a
 * popup still open after this long has no taskpane left to collect it.
 */
export const MSAL_POPUP_HANDOFF_GRACE_MS = 3000;

/**
 * MSAL sends a finished Microsoft sign-in popup back to the add-in's origin with the response in the
 * URL fragment. The add-in routes in memory and never puts state in the fragment itself, so a
 * fragment carrying an OAuth `state` together with a `code` or `error` can only be that landing.
 */
export const isMsalPopupLanding = (hash: string): boolean => {
  const response = new URLSearchParams(hash.replace(/^#/, ''));
  return response.has('state') && (response.has('code') || response.has('error'));
};

/**
 * Keeps a sign-in popup from turning into a stray add-in window. Booting the add-in here would
 * render the whole app without an Office host — the blank "Sign in" windows customers reported
 * whenever the taskpane that opened the popup was closed or reloaded before sign-in finished.
 * Instead the page stays empty for the opener to read, and closes itself if nobody does.
 */
export const releaseMsalPopupLanding = (popup: Pick<Window, 'close' | 'setTimeout'>) => {
  popup.setTimeout(() => popup.close(), MSAL_POPUP_HANDOFF_GRACE_MS);
};
